import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "maison.token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Auth
export const apiRegister = async (payload) => {
  const { data } = await client.post("/auth/register", payload);
  return data;
};

export const apiLogin = async (payload) => {
  const { data } = await client.post("/auth/login", payload);
  return data;
};

export const apiForgotPassword = async (email) => {
  const { data } = await client.post("/auth/forgot-password", { email });
  return data;
};

export const apiResetPassword = async (token, password) => {
  const { data } = await client.post("/auth/reset-password", { token, password });
  return data;
};

export const apiLogout = async () => {
  try {
    await client.post("/auth/logout");
  } catch {}
};

export const apiMe = async () => {
  const { data } = await client.get("/auth/me");
  return data;
};

// Appointments
export const listAppointments = async () => {
  const { data } = await client.get("/appointments");
  return data;
};

export const listHistory = async () => {
  const { data } = await client.get("/appointments/history");
  return data;
};

export const deleteAllHistory = async () => {
  const { data } = await client.delete("/appointments/history");
  return data;
};

export const createAppointment = async (payload) => {
  const { data } = await client.post("/appointments", payload);
  return data;
};

export const updateAppointment = async (id, payload) => {
  const { data } = await client.put(`/appointments/${id}`, payload);
  return data;
};

export const deleteAppointment = async (id) => {
  const { data } = await client.delete(`/appointments/${id}`);
  return data;
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
